const CONFIRM_DELETE_EVENT = 'confirmDelete'

export const dispatchConfirmDelete = (title, message, onConfirm) => {
  document.dispatchEvent(new CustomEvent(CONFIRM_DELETE_EVENT, {
    detail: { title, message, onConfirm }
  }))
}

export const addConfirmDeleteListener = handler => {
  document.addEventListener(CONFIRM_DELETE_EVENT, handler)
  return () => document.removeEventListener(CONFIRM_DELETE_EVENT, handler)
}
